function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

import classnames from 'classnames';
import classNameToStyleName from './classNameToStyleName';
import { baseThemeStyleName, flagIconClassesPrefix, flagIconClassesPrefixName } from './constants';
export var makeClassesObject = function makeClassesObject(props, options) {
  var _ref;

  var code = props.code,
      _props$flip = props.flip,
      flip = _props$flip === void 0 ? '' : _props$flip,
      _props$size = props.size,
      size = _props$size === void 0 ? '' : _props$size,
      _props$squared = props.squared,
      squared = _props$squared === void 0 ? false : _props$squared,
      rotate = props.rotate,
      className = props.className,
      styleName = props.styleName;
  var themeStyles = options.themeStyles,
      useCssModules = options.useCssModules;
  return _ref = {}, _defineProperty(_ref, flagIconClassesPrefixName, true), _defineProperty(_ref, "".concat(flagIconClassesPrefix, "squared"), squared), _defineProperty(_ref, "".concat(flagIconClassesPrefix).concat(size), size), _defineProperty(_ref, "".concat(flagIconClassesPrefix).concat(code), code), _defineProperty(_ref, "".concat(flagIconClassesPrefix, "flip-").concat(flip), flip), _defineProperty(_ref, "".concat(flagIconClassesPrefix, "rotate-").concat(rotate || ''), rotate), _defineProperty(_ref, baseThemeStyleName, useCssModules && themeStyles && themeStyles[baseThemeStyleName]), _defineProperty(_ref, styleName || '', useCssModules && themeStyles && styleName && themeStyles[styleName]), _defineProperty(_ref, className || '', className), _ref;
};
export default (function (props, options, styles) {
  var useCssModules = options.useCssModules;
  var classesObject = makeClassesObject(props, options);
  var strClasses = classnames(classesObject);

  if (useCssModules) {
    var className = props.className;
    var aClasses = strClasses.split(' ');
    var nClasses = aClasses.length;
    strClasses = aClasses.map(function (c, i) {
      if (className && i === nClasses - 1) return c;
      return classNameToStyleName(c, styles || {});
    }).join(' ');
  }

  return strClasses;
});